import * as React from "react";
import { render } from "react-dom";
import StaticPage from "./Components/StaticPage/StaticPage";

const STATIC_PAGE = 'static';
const ROOT = window.__PRELOADED_STATE__.urls.root;
const showStaticPage = window.location.pathname.replace(ROOT, '') === STATIC_PAGE;

if (showStaticPage) {
  render(<StaticPage />, document.getElementById('app'));
} else {
  require('./app');
}